export default __webpack_public_path__ + "static/b-active-bottle-with-runner-9492f9844a63b53cae62f86b607cfd62.jpg";